import React, { CSSProperties } from "react";
import styled from "styled-components";

const ConditionalImageElem = styled.div<{ highlight?: boolean }>`
  position: relative;

  ${props =>
    props.highlight
      ? `
    img {
      box-shadow: 3px 3px 6px rgba(0,0,0,.4);
      border-radius: 5px;
    }
  `
      : ""}

  .desktop-image {
    display: block;
  }

  .mobile-image {
    display: none;
  }

  @media screen and (max-width: 960px) {
    .desktop-image {
      display: none;
    }

    .mobile-image {
      display: block;
    }
  }

  img {
    max-width: 100%;
    min-width: 100%;
  }
`;

interface ConditionalImageProps {
  className?: string;
  style?: CSSProperties;
  highlight?: boolean;
  mobileImage: string;
  desktopImage: string;
}

export function ConditionalImage(props: ConditionalImageProps): JSX.Element {
  return (
    <ConditionalImageElem highlight={props.highlight} className={props.className} style={props.style}>
      <img className="desktop-image" src={props.desktopImage} />
      <img className="mobile-image" src={props.mobileImage} />
    </ConditionalImageElem>
  );
}
